import React, { useEffect, useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { DIR_RTL } from "../../../constants/ThemeConstant";
import { useSelector } from "react-redux";
import { Button, Divider, notification } from "antd";
import { useHistory } from "react-router-dom";
import "./style.css";
import { PaymentIcon } from "assets/svg/icon";



function CheckoutThree() {
    const { theme: { direction, locale }, fetchedData: {storeData} } = useSelector(state => state);
    const [selectPayment, setSelectPayment] = useState('');
    const history = useHistory();
    const selected_mode = localStorage.getItem('selected-mode');

    useEffect(()=>{
        if (localStorage.getItem('payType')!== null){
            setSelectPayment(localStorage.getItem('payType'));
        } else {
            setSelectPayment(storeData?.cashPayment ? "cash" : storeData?.knetPayment ? "k-net" : storeData?.cardPayment ? "visa/ms" : "");
        }
    }, [])

    return (
        <div className="checkOut-page-style">
            <div className="checkOutNav">
                <div onClick={() => window.history.back()}>
                    <ArrowLeftOutlined rotate={direction === DIR_RTL ? 180 : 0} style={{ fontSize: '24px', cursor: 'pointer', color: 'black' }} />
                </div>
                <div className='text-center w-100' style={{ fontSize: "17px", color: '#000', fontWeight: '600' }}>Checkout</div>
            </div>
            <div className="checkout-status">
                <span style={{backgroundColor: "var(--primaryColor)"}}/>
                {selected_mode === 'pickup' ? '' : <span style={{backgroundColor: "var(--primaryColor)"}}/>}
                <span style={{backgroundColor: "var(--primaryColor)"}}/>
                <span style={{backgroundColor: "grey"}}/>
            </div>
            <div className="checkOut-content">
                <div className={"text-center"}>
                    {PaymentIcon('mt-4', 'var(--primaryColor)')}
                    <h2 className={'mt-2'}> Payment Method </h2>
                    <p className={'h4 text-muted'}> We’ll use it to get back to you for order updates </p>
                </div>
                <div className={'checkOut-form mt-5'}>
                    <div className="checkOut-payment">
                        {storeData?.cashPayment && 
                            <div className={`checkOut-payment-items ${selectPayment === 'cash' && 'selected-payment'}`} onClick={() => setSelectPayment('cash')}>
                                <img src="/img/money.svg" alt="#" />
                                <span> Cash </span>
                            </div>
                        }
                        {storeData?.knetPayment &&
                            <div className={`checkOut-payment-items ${selectPayment === 'k-net' && 'selected-payment'}`} onClick={() => setSelectPayment('k-net')}>
                                <img src="/img/cash.svg" alt="#" />
                                <span> K-net </span>
                            </div>
                        } 
                        {storeData?.cardPayment &&
                            <div className={`checkOut-payment-items ${selectPayment === 'visa/ms' && 'selected-payment'}`} onClick={() => setSelectPayment('visa/ms')}>
                                <img src="/img/visa-master.svg" alt="#" />
                                <span> Visa/MS </span>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className='orderCheckoutContainer branch-btn'>
                <Button onClick={() => {
                    if (!selectPayment){
                        notification['error']({message: 'Choose one payment method'})
                    }else{
                        history.push('checkOutFour');
                        localStorage.setItem('payType', selectPayment);
                    }
                }} className={`w-100 orderCheckout btn-project primaryColor`}>
                    Next
                </Button>
            </div>
            {/* <div className="checkOut-finish-btn">
                <button className="primaryColor" onClick={() => {
                    history.push('checkOutFour');
                    localStorage.setItem('payType', selectPayment);
                }}> <span> Next </span> </button>
            </div> */}
        </div>
    )
}


export default CheckoutThree;